import {
	hasLoadings,
	hasExclusions,
	getLoadingsRatioTotal,
	getLoadingCode,
	getExclusionCode
} from "@/modules/reports/schemas/utils/"

import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = [
		{ wpx: 150 },
		{ wpx: 50 },
		{ wpx: 50 },
		{ wpx: 300 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	["Template 09 - Record of policies with Premium Loading/CBE"],
	[
		"VHIS Cert No.",
		"Age",
		"Sex",
		"Underwriting/ Re-underwriting result",
		"Level of Premium Loading Rate (%)",
		"Reason for Premium Loading 1",
		"Reason for Premium Loading 2",
		"Reason for Premium Loading 3",
		"Reason for Premium Loading 4",
		"Reason for Premium Loading 5",
		"Reason for CBE 1",
		"Reason for CBE 2",
		"Reason for CBE 3",
		"Reason for CBE 4",
		"Reason for CBE 5"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = get(policy, "contractInsured[0].dateOfBirth", null)
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	payload.map(policy => {
		const underwritingResult = getUnderwritingResult(policy)
		if (underwritingResult != null)
			output.push([
				"S00027-01-000-02",
				getAge(policy),
				get(policy, "contractInsured[0].gender", null),
				underwritingResult,
				getLoadingsRatioTotal(policy) * 100,
				getLoadingCode(policy, 0),
				getLoadingCode(policy, 1),
				getLoadingCode(policy, 2),
				getLoadingCode(policy, 3),
				getLoadingCode(policy, 4),
				getExclusionCode(policy, 0),
				getExclusionCode(policy, 1),
				getExclusionCode(policy, 2),
				getExclusionCode(policy, 3),
				getExclusionCode(policy, 4)
			])
	})
	return output
}

const getUnderwritingResult = policy => {
	const status = policy.status
	const loadings = hasLoadings(policy)
	const exclusions = hasExclusions(policy)

	if (status === "ISSUED" && loadings === true && exclusions === false)
		return "Offer with Premium Loading only"
	if (status === "ISSUED" && loadings === false && exclusions === true)
		return "Offer with CBE only"
	if (status === "ISSUED" && loadings === true && exclusions === true)
		return "Offer with Premium Loading and CBE only"
}
